import { ContentService } from "../../../services/content.service.js";

export class SeriesHero {
    constructor(container, seriesData, user, onLikeToggle) {
        this.container = container;
        this.seriesData = seriesData;
        this.user = user;
        this.onLikeToggle = onLikeToggle;

        // State
        this.isLiked = false;
        this.playActionLabel = "첫 화 보기"; // Default Korean
        this.playActionHandler = null;
    }

    setLikeState(isLiked) {
        this.isLiked = isLiked;
        this.updateLikeButton();
    }

    render() {
        // Robust Author Name: Check authorName (DB), author (Legacy), or 'Unknown'
        const author = this.seriesData.authorName || this.seriesData.author || "Unknown Author";
        const authorId = this.seriesData.authorId;
        const coverImg = this.seriesData.coverImage || "https://placehold.co/600x400/18181b/52525b?text=No+Cover";
        const title = this.seriesData.title;
        const desc = this.seriesData.description || "작품 설명이 없습니다.";

        // Tags
        const tags = this.seriesData.tags || [];

        this.container.innerHTML = `
        <div class="relative w-full min-h-[45vh] md:h-[50vh] overflow-hidden flex flex-col justify-end group pt-24 md:pt-0">
            <!-- Background: Parallax-like effect could be added here -->
            <div class="absolute inset-0 z-0">
                <img src="${coverImg}" class="w-full h-full object-cover opacity-60 blur-sm scale-110 pointer-events-none transition-transform duration-1000 group-hover:scale-100" alt="Backdrop">
                <div class="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/60 to-transparent"></div>
            </div>
            
            <div class="relative z-10 p-6 max-w-6xl mx-auto w-full pb-12">
                <div class="flex flex-col md:flex-row gap-8 items-end">
                    <!-- Cover Image -->
                    <div class="hidden md:block flex-shrink-0 relative group/cover">
                         <img src="${coverImg}" class="w-48 h-72 object-cover rounded-lg shadow-2xl border-2 border-zinc-800 transition-transform duration-300 group-hover/cover:scale-105">
                         <!-- Admin/Owner Edit Button could go here -->
                    </div>

                    <div class="mb-2 w-full">
                        <!-- Author Link -->
                        <!-- Author Link -->
                        <div class="mb-3 relative z-20">
                             ${authorId ?
                `<button class="text-zinc-200 hover:text-white text-sm font-bold flex items-center gap-1 transition-colors bg-zinc-900/50 hover:bg-zinc-900/80 border border-zinc-700/50 px-3 py-1 rounded-full backdrop-blur-md shadow-sm" onclick="event.preventDefault(); window.router.navigate('/user/${authorId}')">
                    <span class="material-symbols-outlined text-sm">person</span> ${author}
                 </button>` :
                `<span class="text-zinc-300 text-sm font-bold flex items-center gap-1 px-3 py-1 bg-black/20 rounded-full"><span class="material-symbols-outlined text-sm">person</span> ${author}</span>`
            }
                        </div>

                        <!-- Title -->
                        <h1 class="text-3xl md:text-5xl font-black mb-4 leading-tight drop-shadow-lg text-white tracking-tight">
                            ${title}
                        </h1>
                        
                        <!-- Badges & Stats -->
                         <div class="flex items-center gap-2 mb-6 flex-wrap">
                             ${this.seriesData.isAdult ? '<span class="px-2 py-0.5 bg-red-600/90 text-white text-[10px] font-black rounded flex items-center gap-1 shadow-lg shadow-red-900/50 backdrop-blur-sm border border-red-500/50"><span class="material-symbols-outlined text-[12px]">18_up_rating</span> 19+</span>' : ''}
                             ${this.seriesData.isAI ? '<span class="px-2 py-0.5 bg-purple-600/20 text-purple-300 border border-purple-500/30 text-[10px] font-bold rounded flex items-center gap-1 select-none backdrop-blur-sm"><span class="material-symbols-outlined text-[12px]">smart_toy</span> AI Generated</span>' : ''}
                             <span class="px-2 py-0.5 bg-zinc-800/80 text-zinc-300 border border-zinc-600/50 text-[10px] font-bold rounded capitalize backdrop-blur-sm">${this.seriesData.type === 'webnovel' ? '웹소설' : (this.seriesData.type || 'Series')}</span>
                             
                             <!-- Tags -->
                             ${tags.slice(0, 3).map(tag => `<span class="px-2 py-0.5 bg-zinc-800/50 text-zinc-400 border border-zinc-700/50 text-[10px] rounded hover:text-white transition-colors cursor-pointer">#${tag}</span>`).join('')}
                         </div>

                        <p class="text-zinc-300/90 text-sm md:text-base max-w-2xl drop-shadow-md line-clamp-3 leading-relaxed mb-8 mix-blend-plus-lighter">
                            ${desc}
                        </p>
                        
                        <!-- Action Buttons -->
                        <div class="flex gap-3 items-center">
                            <button id="btn-hero-play" class="bg-white text-black px-8 py-3 rounded-full font-bold hover:bg-zinc-200 transition-all transform hover:scale-105 active:scale-95 flex items-center gap-2 shadow-xl shadow-white/10 group/play">
                                <span class="material-symbols-outlined group-hover/play:fill-current">play_arrow</span>
                                <span id="btn-play-text">${this.playActionLabel}</span>
                            </button>

                            <button id="btn-hero-like" class="w-12 h-12 rounded-full border border-zinc-600/50 bg-black/20 backdrop-blur flex items-center justify-center transition-all hover:bg-zinc-800 hover:border-zinc-500Group">
                                <span class="material-symbols-outlined text-zinc-300">favorite</span>
                            </button>
                            
                             <button id="btn-hero-share" class="w-12 h-12 rounded-full border border-zinc-600/50 bg-black/20 backdrop-blur flex items-center justify-center transition-all hover:bg-zinc-800 hover:border-zinc-500 text-zinc-300">
                                <span class="material-symbols-outlined text-zinc-300 text-sm">share</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;

        this.bindEvents();
    }

    bindEvents() {
        const playBtn = this.container.querySelector('#btn-hero-play');
        const likeBtn = this.container.querySelector('#btn-hero-like');
        const shareBtn = this.container.querySelector('#btn-hero-share');

        if (playBtn) {
            playBtn.onclick = this.playActionHandler ? this.playActionHandler : () => console.warn('No play action set');
        }

        // [FIX] Persistent Pick Logic
        if (likeBtn) {
            likeBtn.onclick = async () => {
                if (!this.user) {
                    if (confirm("작품을 찜(Pick)하려면 로그인이 필요합니다.\n로그인하시겠습니까?")) {
                        // [RETENTION] Smart Redirect
                        const currentPath = window.location.hash.slice(1); // /series/123
                        // Determine Base URL logic?
                        // Actually, just save to Session logic manually or rely on Router?
                        // Router capture is for ENTRY.
                        // For manual navigation:
                        sessionStorage.setItem('auth_redirect', currentPath);
                        window.router.navigate('/login');
                    }
                    return;
                }

                // Optimistic Update
                const newState = !this.isLiked;
                this.setLikeState(newState);

                try {
                    // Toast
                    if (newState) window.Modal.toast("📚 서재에 담았습니다 (Pick)");
                    else window.Modal.toast("🗑️ 서재에서 제거했습니다");

                    await this.onLikeToggle(likeBtn);
                } catch (e) {
                    console.error("Pick Error", e);
                    this.setLikeState(!newState); // Revert
                    window.Modal.toast("오류가 발생했습니다.");
                }
            };
        }

        // [FIX] Smart Share Logic
        if (shareBtn) {
            shareBtn.onclick = async () => {
                const title = this.seriesData.title;
                // [RETENTION] Build Root Query URL
                // Format: https://domain.com/?ref={uid}&redirect={path}#{path}
                // Note: We use window.location.origin

                const origin = window.location.origin;
                const path = window.location.hash; // #/series/123
                const cleanPath = path.replace('#', ''); // /series/123

                // If user is logged in, attach Ref Code
                // Assuming user object has uid (or check PointService logic for code?)
                // For now, use UID as simplest Ref or just generic if guest.
                let refParam = "";
                if (this.user) {
                    refParam = `&ref=${this.user.referralCode || this.user.uid}`;
                }

                // [SEO] Dynamic Share Link (Cloud Function for OG Tags)
                // This ensures Kakao/Twitter bots see the meta tags generated by the server.
                // const origin = window.location.origin; // Already declared above
                const typePath = (this.seriesData.type === 'webtoon') ? 'webtoon' : 'novel';

                // [SEO + Referral] 
                // Combine SEO Path (/share/...) with Referral Query Params
                let smartUrl = `${origin}/share/${typePath}/${this.seriesData.id}`;

                // Append params if they exist (e.g. ?ref=user123)
                if (refParam) {
                    smartUrl += `?${refParam.replace('&', '')}`; // Remove leading & if present, or just handle logic cleanly
                }

                try {
                    // Mobile Native Share
                    if (navigator.share) {
                        await navigator.share({
                            title: `[썰화월드] ${title}`,
                            text: `"${title}" 작품을 추천합니다! 무료로 감상해보세요.`,
                            url: smartUrl
                        });
                    } else {
                        // Desktop Copy
                        await navigator.clipboard.writeText(smartUrl);
                        window.Modal.toast("🔗 초대 링크가 복사되었습니다!");
                    }
                } catch (e) {
                    console.warn("Share failed/cancelled", e);
                    // Fallback Copy if share denied?
                    try {
                        await navigator.clipboard.writeText(smartUrl);
                        window.Modal.toast("🔗 초대 링크가 복사되었습니다!");
                    } catch (e2) { }
                }
            };
        }
    }

    updateLikeButton() {
        const btn = this.container.querySelector('#btn-hero-like');
        if (!btn) return;
        const icon = btn.querySelector('span');

        // [FIX] Ensure Explicit Logic: True = Red (Picked), False = Gray (Unpicked)
        if (this.isLiked === true) {
            // Picked State: Red Heart, Filled
            // Remove Gray classes, Add Red classes
            btn.className = "w-12 h-12 rounded-full border border-red-500 bg-red-500/20 backdrop-blur flex items-center justify-center transition-all text-red-500 scale-110 shadow-[0_0_15px_rgba(239,68,68,0.5)]";
            icon.classList.add('fill-current'); // Material Symbols 'filled' style often relies on font variation or class
            icon.style.fontVariationSettings = "'FILL' 1"; // Force fill
        } else {
            // Unpicked State: Gray
            btn.className = "w-12 h-12 rounded-full border border-zinc-600/50 bg-black/20 backdrop-blur flex items-center justify-center transition-all hover:bg-zinc-800 hover:border-zinc-500 text-zinc-300";
            icon.classList.remove('fill-current');
            icon.style.fontVariationSettings = "'FILL' 0"; // Force outline
        }
    }

    /**
     * Logic to decide which episode to play
     * (First, or Last Read).
     */
    setPlayButtonAction(label, onClick) {
        this.playActionLabel = label;
        this.playActionHandler = onClick;

        // Reactive Update if DOM exists
        const btn = this.container.querySelector('#btn-hero-play');
        const text = this.container.querySelector('#btn-play-text');
        if (btn && text) {
            text.textContent = label;
            btn.onclick = onClick;
        }
    }
}
